import { bool, func, number, oneOfType, string } from 'prop-types'

import { FormConsumer } from 'views/components/atoms/Form'

const Textarea = props => {
  const {
    name,
    value,
    defaultValue,
    disableAutoCompleteAndFriends,
    inputType,
    register,
    dataQa,
    ...rest
  } = props

  let restProps = rest

  if (disableAutoCompleteAndFriends) {
    restProps = {
      ...restProps,
      ...{
        autoComplete: 'off',
        autoCorrect: 'off',
        autoCapitalize: 'off',
        spellCheck: 'false',
      },
    }
  }

  // Component should have either `value` or `defaultValue` set.
  // Default `null` is also value, so it cannot be passed as is.
  const values = { value, defaultValue }
  if (value === null) {
    delete values.value
  } else if (defaultValue === null) {
    delete values.defaultValue
  } else {
    throw new Error(
      'Component should not have both `value` and `defaultValue` set'
    )
  }

  return (
    <FormConsumer>
      {formName => (
        <textarea
          {...restProps}
          {...values}
          data-qa-id={dataQa || `${formName}-${name}`}
          name={name}
          ref={register}
        />
      )}
    </FormConsumer>
  )
}

Textarea.propTypes = {
  name: string.isRequired,
  value: oneOfType([string, number]),
  defaultValue: oneOfType([string, number]),
  disabled: bool,
  disableAutoCompleteAndFriends: bool,
  rows: number,
  required: bool,
  inputType: string,
  register: func,
  dataQa: string,
}

Textarea.defaultProps = {
  value: null,
  defaultValue: null,
  disabled: false,
  disableAutoCompleteAndFriends: false,
  rows: 2,
  required: false,
  inputType: '',
  register: null,
  dataQa: undefined,
}

export default Textarea
